import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { ProdutividadeService } from '../produtividade-service/produtividade.service';
import { Filtros } from '../../../../shared/crud/Filtro/Filtros';
import { ListaBase } from '../../../../shared/crud/ListaBase';
import { ExportExcelService } from '../../../../shared/excel-service/export-excel.service';
import { FiltroService } from '../../../../shared/filtro/filtro.service';
import { FormatarData } from '../../../../shared/formatarData';
import { DecimalPipe } from '@angular/common';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-produtividade-lista',
  templateUrl: './produtividade-lista.component.html',
  styleUrls: ['./produtividade-lista.component.css']
})
export class ProdutividadeListaComponent extends ListaBase implements OnInit {
  columns: any[]
  gruposEconomicos = [];
  regioes = [];
  dealers = []
  display: boolean = false;
  data: any;
  carregando = false;
  id: number
  produtividade = 0;
  produtividadeHT: number;
  produtividadeHTStrg: string;
  eficiencia = 0;
  eficienciaHV: number;
  eficienciaHVStrg: string;
  utilizacao = 0;
  utilizacaoHV: number;
  utilizacaoHVStrg: string;
  finalDate: Date;
  configShowNumber = {
    animation: 'count',
    format: '(.ddd),dd'
  };

  max
  InicialData
  FinalData
  _selectedColumns: any[];
  subscription: any

  @ViewChild('dataInicialView') dataInicialView;
  @ViewChild('dataFinalView') dataFinalView;

  dadosTranslate = {
    "horasTrabalhadas": "rmpv.produtividade.grid.horasTrabalhadasGrid",
    "horasDisponiveis": "rmpv.produtividade.grid.horasDisponiveisGrid",
    "horasVendidas": "rmpv.produtividade.grid.horasVendidasGrid",
    "percentualMaoDeObra": "rmpv.produtividade.grid.porcentagemProdutividadeGrid",
    "statusMaoDeObra": "rmpv.produtividade.grid.statusProdutividadeGrid",
    "percentualProdutividade": "rmpv.produtividade.grid.porcentagemEficienciaGrid",
    "statusProdutividade": "rmpv.produtividade.grid.statusEficienciaGrid",
    "percentualEficiencia": "rmpv.produtividade.grid.porcentagemUtilizacaoGrid",
    "statusEficiencia": "rmpv.produtividade.grid.statusUtilizacaoGrid",
  }

  getTranslate(value) {
    if (value?.statusEficiencia == 'Ruim') {
      return this.translate.currentLang == "br" ? value.statusEficiencia = "Ruim" : value.statusEficiencia = "Bad";
    }
    if (value?.statusEficiencia == 'Ideal') {
      return value.statusEficiencia = "Ideal";
    }
    if (value?.statusMaoDeObra == 'Ruim') {
      return this.translate.currentLang == "br" ? value.statusMaoDeObra = "Ruim" : value.statusMaoDeObra = "Bad";
    }
    if (value?.statusMaoDeObra == 'Ideal') {
      return value.statusMaoDeObra = "Ideal";
    }
    if (value?.statusProdutividade == 'Ruim') {
      return this.translate.currentLang == "br" ? value.statusProdutividade = "Ruim" : value.statusProdutividade = "Bad";
    }
    if (value?.statusProdutividade == 'Ideal') {
      return value.statusProdutividade = "Ideal";
    }

    return this.dadosTranslate[value];
  }

  constructor(service: ProdutividadeService, toastr: ToastrService, router: Router,
    private filter: FiltroService,
    private exportExcelService: ExportExcelService,
    private formBuilder: FormBuilder,
    private number: DecimalPipe,
    private translate: TranslateService) {
    super(service, toastr, router);
    const max = new Date();
    this.max = { 'year': max.getFullYear(), 'month': max.getMonth() + 1, 'day': max.getUTCDate() };


    this.InicialData = moment(this.InicialData).startOf('month').format('YYYY-MM-DD');
    this.FinalData = moment(this.FinalData).format('YYYY-MM-DD');
    this.nomeModulo = 'produtividade';
  }

  ngOnInit() {
    this.changeLanguageValue();
    this.getAll();
    this.columns = [
      { field: 'edit', header: 'a', width: '3rem' },
      { field: 'descricao', header: 'Dealer', width: '6rem' },
      { field: 'horasTrabalhadas', header: 'rmpv.produtividade.grid.horasTrabalhadasGrid', width: '3rem', type: this.number, arg1: '1.2-2' },
      { field: 'horasDisponiveis', header: 'rmpv.produtividade.grid.horasDisponiveisGrid', width: '3rem', type: this.number, arg1: '1.2-2' },
      { field: 'horasVendidas', header: 'rmpv.produtividade.grid.horasVendidasGrid', width: '3rem', type: this.number, arg1: '1.2-2' },
      { field: 'percentualMaoDeObra', header: 'rmpv.produtividade.grid.porcentagemProdutividadeGrid', width: '8rem', align: 'center' },
      { field: 'statusMaoDeObra', header: 'rmpv.produtividade.grid.statusProdutividadeGrid', width: '9rem' },
      { field: 'percentualProdutividade', header: 'rmpv.produtividade.grid.porcentagemEficienciaGrid', width: '8rem', align: 'center' },
      { field: 'statusProdutividade', header: 'rmpv.produtividade.grid.statusEficienciaGrid', width: '9rem' },
      { field: 'percentualEficiencia', header: 'rmpv.produtividade.grid.porcentagemUtilizacaoGrid', width: '6rem', align: 'center' },
      { field: 'statusEficiencia', header: 'rmpv.produtividade.grid.statusUtilizacaoGrid', width: '8rem' },
    ];

    this._selectedColumns = this.columns;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.columns.filter(col => val.includes(col));
  }

  getAll() {
    this.preencherGruposEconomicos()
    this.preencherRegioes();
    this.preencherDealers();
    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }
    this.carregando = true
    this.service.buscar(objFiltro).then(res => {
      this.data = res.dados

      this.produtividade = res.produtividade.ideal;
      this.produtividadeHT = res.produtividade.percentualProdutividade;
      this.produtividadeHTStrg = `${res.produtividade.horasTrabalhadas}%`;

      this.utilizacao = res.utilizacao.ideal;
      this.utilizacaoHV = res.utilizacao.percentualUtilizacao;
      this.utilizacaoHVStrg = `${res.utilizacao.horasVendidas}%`;

      this.eficiencia = res.eficiencia.ideal;
      this.eficienciaHV = res.eficiencia.percentualEficiencia;
      this.eficienciaHVStrg = `${res.eficiencia.horasVendidas}%`;

      this.carregando = false
    });
    this.display = false
  }
  //dataFinal
  showDialog() {
    this.display = true;
  }

  cleanFilter() {
    this.filtros.dealers = undefined;
    this.filtros.regiao = undefined;
    this.filtros.grupo_economico = undefined;
  }

  //export Excel
  exportExcel() {
    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }
    this.service.buscar(objFiltro).then(res => {
      let dados = res.dados;
      this.exportExcelService.nomeModulo = this.nomeModulo;
      this.exportExcelService.ExportTOExcelJSON(dados.map(r => {
        let linha = {};

        this._selectedColumns.forEach(c => {
          if (c.field != 'detalhe') {
            linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
          }
        });

        return linha;
      }));
    }

    )
  }

  private translateHeader(item) {
    if (item == "rmpv.produtividade.grid.horasTrabalhadasGrid") {
      return this.translate.currentLang == "br" ? "HT" : "WH";
    }
    if (item == "rmpv.produtividade.grid.horasDisponiveisGrid") {
      return this.translate.currentLang == "br" ? "HD" : "WA";
    }
    if (item == "rmpv.produtividade.grid.horasVendidasGrid") {
      return this.translate.currentLang == "br" ? "HV" : "HS";
    }
    if (item == "rmpv.produtividade.grid.porcentagemProdutividadeGrid") {
      return this.translate.currentLang == "br" ? "Produtividade" : "Productivity %";
    }
    if (item == "rmpv.produtividade.grid.statusProdutividadeGrid") {
      return this.translate.currentLang == "br" ? "Status Produtividade" : "Productivity Status";
    }
    if (item == "rmpv.produtividade.grid.porcentagemEficienciaGrid") {
      return this.translate.currentLang == "br" ? "Eficiência" : "Efficiency %";
    }
    if (item == "rmpv.produtividade.grid.statusEficienciaGrid") {
      return this.translate.currentLang == "br" ? "Status Eficiência" : "Efficiency Status";
    }
    if (item == "rmpv.produtividade.grid.porcentagemUtilizacaoGrid") {
      return this.translate.currentLang == "br" ? "Utilização" : "Utility %";
    }
    if (item == "rmpv.produtividade.grid.statusUtilizacaoGrid") {
      return this.translate.currentLang == "br" ? "Status Utilização" : "Utility Status";
    }

    return item;
  }

  private translateField(item) {
    if (item == "Ruim") {
      return this.translate.currentLang == "br" ? "Ruim" : "Bad";
    }

    return item;
  }

  goToRmpvDetalhado(index: number) {
    const id = this.data[index].id;
    let url = '';
    for (const filtro in this.filtros) {
      if (this.filtros.hasOwnProperty(filtro)) {
        url += url ? '&' + filtro + '=' + this.filtros[filtro] : '?' + filtro + '=' + this.filtros[filtro];
      }
    }

    this.router.navigateByUrl('produtividade/dealer/produtivo' + url + '&' + 'dealer=' + id);
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.grupo_economico
      || this.filtros.dealers
      || this.filtros.regiao
      || this.filtros.data_inicial
      || this.filtros.data_final;
  }

  private preencherGruposEconomicos() {
    this.filter.buscar('grupo_economico')
      .then(res => { this.gruposEconomicos = res.filtros; });
  }

  private preencherRegioes() {
    this.filter.buscar('regiao')
      .then(res => { this.regioes = res.filtros; });
  }

  private preencherDealers() {
    this.filter.buscar('dealer')
      .then(res => { this.dealers = res.filtros; });
  }

  set DataInicial(data) { this.filtros.data_inicial = this.getDataString(data); }
  get DataInicial(): any { return this.tratarGetDropDown(this.filtros.data_inicial); }

  set DataFinal(data) { this.filtros.data_final = this.getDataString(data); }
  get DataFinal(): any { return this.tratarGetDropDown(this.filtros.data_final); }

  tratarSetDropDown(id: string): number {
    if (id) {
      return +id;
    } else {
      return null;
    }
  }

  tratarGetDropDown(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return '';
    }
    return selecionado;
  }

  set dataInicial(data) {
    this.filtros.data_inicial = this.getDataString(data);
  }

  set dataFinal(data) {
    this.filtros.data_final = this.getDataString(data);
  }

  limparDataInicial() {
    this.dataInicialView._elRef.nativeElement.value = moment(this.InicialData).startOf('month').format('DD/MM/YYYY');
    this.filtros.data_inicial = moment(this.InicialData).startOf('month').format('YYYY-MM-DD');
  }

  limparDataFinal() {
    this.dataFinalView._elRef.nativeElement.value = moment(this.FinalData).format('DD/MM/YYYY');
    this.filtros.data_final = moment(this.FinalData).format('YYYY-MM-DD');
  }

  getDataString(data): any {
    return new FormatarData(
      data.year,
      data.month,
      data.day,
      0,
      0,
      0
    ).getDataString();
  }

  private changeLanguageValue() {
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.carregando = true;
        this.getAll();
      });
  }
}